import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=73fd98cf"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"
import style0 from "./Sort.vue?vue&type=style&index=0&id=73fd98cf&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73fd98cf')) {
      api.createRecord('73fd98cf', component.options)
    } else {
      api.reload('73fd98cf', component.options)
    }
    module.hot.accept("./Sort.vue?vue&type=template&id=73fd98cf", function () {
      api.rerender('73fd98cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/Sort.vue"
export default component.exports